module.exports = "<div class=\"not-found\">\r\n  <div class=\"status\">404</div>\r\n  <h1 class=\"heading\">{{ 'notFound' | translate }}</h1>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/NotFoundComponent/notFound.component.html
// module id = ./src/app/common/components/NotFoundComponent/notFound.component.html
// module chunks = main